import React from "react";
import { MdDelete } from "react-icons/md";

/**
 * Horizontal thumbnail strip showing captured pages.
 * Displays at the bottom when there are captured pages.
 */
const ThumbnailStrip = ({ pages, onPageTap, onDeletePage, onDone }) => {
  if (!pages || pages.length === 0) return null;

  return (
    <div className="ds-thumbnail-strip">
      <span className="ds-page-counter">
        {pages.length} {pages.length === 1 ? "page" : "pages"}
      </span>

      {pages.map((page, idx) => (
        <div
          key={page.id || idx}
          className="ds-thumb-item"
          onClick={() => onPageTap(idx)}
          role="button"
          aria-label={`Page ${idx + 1}`}
        >
          {/* Delete trash bin on top-left corner */}
          <button
            type="button"
            className="ds-thumb-delete-btn"
            onClick={(e) => {
              e.stopPropagation();
              onDeletePage?.(idx);
            }}
            title="Delete page"
            aria-label={`Delete page ${idx + 1}`}
          >
            <MdDelete />
          </button>

          <img src={page.url} alt={`Page ${idx + 1}`} loading="lazy" />
          <span className="ds-thumb-number">{idx + 1}</span>
          {page.quality && (
            <span className="ds-thumb-quality">
              {page.quality.quality === "good"
                ? "🟢"
                : page.quality.quality === "fair"
                ? "🟡"
                : "🔴"}
            </span>
          )}
        </div>
      ))}

      <button className="ds-done-btn" onClick={() => onDone?.()}>
        Done
      </button>
    </div>
  );
};

export default ThumbnailStrip;
